// assets/gift-message.js
// Sanitization + char counter for the cart-level gift message.
// Loaded deferred by layout/theme.liquid. No deps.

(function () {
  'use strict';

  var MAX = 200;

  // Drop < >, control chars, emoji (surrogate pairs).
  //   \u0000-\u001F  : C0 controls (preserve \t \n)
  //   \u007F         : DEL
  //   [\uD800-\uDBFF][\uDC00-\uDFFF] : surrogate pairs (emojis etc.)
  var STRIP_RE = /[<>\x00-\x08\x0B-\x1F\x7F]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var MULTI_WS = /[ \t]{2,}/g;

  function sanitize(s) {
    if (!s) return '';
    var out = s.replace(STRIP_RE, '');
    // Don't collapse newlines the user typed. Collapse runs of
    // space-or-tab only, not the line breaks.
    out = out.replace(MULTI_WS, ' ');
    // Trim to MAX code points.
    var cps = Array.from(out);
    if (cps.length > MAX) cps = cps.slice(0, MAX);
    return cps.join('');
  }

  function cartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/update.js';
  }

  function updateCartAttribute(name, value) {
    var attributes = {};
    attributes[name] = value;

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({attributes: attributes}),
    }).then(function (response) {
      if (!response.ok) throw new Error('Gift message cart update failed');
      return response.json();
    });
  }

  function setStatus(root, status, state) {
    var message = root.getAttribute('data-gm-' + status) || '';
    var el = root.querySelector('[data-gm-status]');
    if (!el) return;
    el.textContent = message;
    el.setAttribute('data-gm-status-state', state || status);
  }

  function showValidationFeedback(root) {
    var el = root.querySelector('[data-gm-validation]');
    if (!el) return;
    el.textContent = root.getAttribute('data-gm-invalid-characters') || '';
    el.hidden = false;
  }

  function saveGiftMessage(root) {
    var ta = root.querySelector('textarea[name^="attributes"]');
    var button = root.querySelector('[data-gm-save]');
    var attributeName = root.getAttribute('data-gm-attribute');
    if (!ta || !button || !attributeName) return Promise.resolve();

    var before = ta.value;
    ta.value = sanitize(before);
    if (ta.value !== before) showValidationFeedback(root);
    button.disabled = true;
    setStatus(root, 'saving', 'saving');

    return updateCartAttribute(attributeName, ta.value)
      .then(function () {
        root.giftMessageSavedValue = ta.value;
        setStatus(root, 'saved', 'saved');
      })
      .catch(function () {
        button.disabled = false;
        setStatus(root, 'save-error', 'error');
      });
  }

  window.GumpsGiftMessage = window.GumpsGiftMessage || {};
  window.GumpsGiftMessage.save = function (button) {
    var root = button && button.closest('[data-gift-message]');
    if (root) return saveGiftMessage(root);
    return Promise.resolve();
  };

  function initDynamicCollapsible(root) {
    var parent = root.closest && root.closest('collapsible-elements');
    if (!parent || !parent.collapsibles || Array.from(parent.collapsibles).indexOf(root) >= 0) return;
    if (root.giftMessageCollapsibleInitialized) return;

    var trigger = root.querySelector('[data-collapsible-trigger]');
    var body = root.querySelector('[data-collapsible-body]');
    if (!trigger || !body) return;
    root.giftMessageCollapsibleInitialized = true;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (root.hasAttribute('open')) {
        root.removeAttribute('open');
        body.style.height = '';
      } else {
        root.setAttribute('open', 'true');
        body.style.height = 'auto';
      }
    });
  }

  function init(root) {
    if (root.giftMessageInitialized) return;
    var ta     = root.querySelector('textarea[name^="attributes"]');
    var ctr    = root.querySelector('[data-gm-counter]');
    var button = root.querySelector('[data-gm-save]');
    var form   = ta && ta.form;
    var attributeName = root.getAttribute('data-gm-attribute');
    if (!ta || !ctr || !button || !attributeName) return;
    root.giftMessageInitialized = true;
    root.setAttribute('data-gm-init', '1');
    root.giftMessageSavedValue = sanitize(ta.value);
    initDynamicCollapsible(root);

    function update() {
      var before = ta.value;
      var after  = sanitize(before);
      if (after !== before) {
        // Preserve cursor position roughly.
        var pos = ta.selectionStart;
        ta.value = after;
        showValidationFeedback(root);
        try { ta.setSelectionRange(pos, pos); } catch (e) { /* readonly */ }
      }
      var len = Array.from(ta.value).length;
      ctr.textContent = len + '/' + MAX;
      ctr.classList.toggle('gift-message__counter--warn', len > MAX * 0.9);
      var dirty = ta.value !== root.giftMessageSavedValue;
      button.disabled = !dirty;
      if (dirty) setStatus(root, 'unsaved', 'unsaved');
    }

    ta.addEventListener('input', update);
    update();

    if (form) {
      form.addEventListener('submit', function () {
        // Final pass to guarantee the network payload is clean.
        ta.value = sanitize(ta.value);
      });
    }
  }

  function clearStale(input) {
    if (input.hasAttribute('data-gm-init')) return;
    input.setAttribute('data-gm-init', '1');
    if (input.getAttribute('data-gm-has-value') !== 'true') return;

    var attributeName = input.getAttribute('data-gm-attribute');
    if (!attributeName) return;

    updateCartAttribute(attributeName, '')
      .then(function () {
        input.setAttribute('data-gm-has-value', 'false');
      })
      .catch(function () {
        // Leave the marker true so a later cart render can retry.
        input.removeAttribute('data-gm-init');
      });
  }

  function boot() {
    document.querySelectorAll('[data-gift-message]').forEach(init);
    document.querySelectorAll('[data-gm-clear-stale]').forEach(clearStale);
  }

  var refreshPending = false;

  function refreshGiftMessage() {
    if (refreshPending) return;
    var holders = document.querySelectorAll('[data-gm-holder]');
    if (!holders.length) return;
    refreshPending = true;

    var current = document.querySelector('[data-gift-message]');
    var currentTextarea = current && current.querySelector('textarea');
    var currentStatus = current && current.querySelector('[data-gm-status]');
    var preserveUnsaved = currentStatus &&
      currentStatus.getAttribute('data-gm-status-state') === 'unsaved';
    var unsavedValue = preserveUnsaved && currentTextarea ? currentTextarea.value : '';
    var cartUrl = window.theme && window.theme.routes && window.theme.routes.cart_url;

    fetch((cartUrl || '/cart') + '?section_id=api-cart-items')
      .then(function (response) {
        if (!response.ok) throw new Error('Gift message refresh failed');
        return response.text();
      })
      .then(function (html) {
        var responseRoot = document.createElement('div');
        responseRoot.innerHTML = html;
        var fresh = responseRoot.querySelector('[data-api-gift-message]');
        if (!fresh) return;

        holders.forEach(function (holder) {
          holder.innerHTML = fresh.innerHTML;
        });
        boot();

        if (preserveUnsaved) {
          var next = document.querySelector('[data-gift-message] textarea');
          if (next) {
            next.value = unsavedValue;
            next.dispatchEvent(new Event('input', {bubbles: true}));
          }
        }
      })
      .catch(function () {
        // The next cart rebuild retries; keep the current UI intact.
      })
      .finally(function () {
        refreshPending = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('theme:product:added', refreshGiftMessage);

  // Re-init when the cart drawer swaps in (Broadcast uses
  // <cart-items> and rebuilds). Observer is cheap; keeps the
  // counter live without a full page reload.
  var obs = new MutationObserver(function () {
    document.querySelectorAll('[data-gift-message]').forEach(function (el) {
      init(el);
    });
    document.querySelectorAll('[data-gm-clear-stale]:not([data-gm-init])').forEach(function (el) {
      clearStale(el);
    });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
